const initheroItems = () => {

	const hero = document.querySelectorAll('.hero__wrapper');


	hero.forEach(section => {

		let sectionSwiper = section.querySelector('.hero__swiper');

		// if (sectionSwiper) {
		// 	sectionSwiper = sectionSwiper.className.split(' ')[1];
		// }

		// if (!sectionSwiper) {
		// 	return false;
		// }
		const swiper = new Swiper(sectionSwiper, {
			slidesPerView: 'auto',
			spaceBetween: 24,
			centeredSlides: true,
			grabCursor: true,
			scrollbar: {
				draggable: true,
				el: '.swiper-scrollbar',
			},
			navigation: {
				nextEl: '.swiper-hero-button-next',
				prevEl: '.swiper-hero-button-prev',
			},
			breakpoints: {
				768: {
					centeredSlides: false,
				}
			}
		});

		swiper.on('slideChange', function () {
			const activeSlide = swiper.slides[swiper.activeIndex];
			if (activeSlide) {
				let video = activeSlide.querySelector('video')
				if (video) {
					activeSlide.querySelector('video').play();
				}
			}
		})

		swiper.on('slideChange', function () {
			const activeSlide = swiper.slides[swiper.activeIndex];
			const prevSlide = swiper.slides[swiper.previousIndex];

			if (activeSlide) {
				let video = activeSlide.querySelector('video')
				if (video) {
					activeSlide.querySelector('video').play();
				}
			}
			if (prevSlide) {
				let video = prevSlide.querySelector('video')
				if (video) {
					prevSlide.querySelector('video').pause();
				}
			}

		})
	});
}

window.addEventListener('DOMContentLoaded', () => {
	initheroItems();
});